// v2/components/EskiYonlendir.js — eski arayuz adreslerini v2 karsiliklarina yonlendirir
// Eski arayuz 2026-09-26'da kapatildi. Yer imleri / eski linkler bozulmasin diye:
//   oturum yoksa -> /login, admin -> `admin` yolu, musteri -> `musteri` yolu
// Yollarda :param kullanilabilir (ornek: '/v2/admin/customers/:code').
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { oturumBilgisi, LOGIN_YOLU } from '../utils/authStore';

export default function EskiYonlendir({ musteri = '/v2', admin = '/v2/admin' }) {
  const params = useParams();
  const { girisli, admin: yonetici } = oturumBilgisi();
  if (!girisli) return <Navigate to={LOGIN_YOLU} replace />;
  const doldur = (yol) => yol.replace(/:(\w+)/g, (_, k) => encodeURIComponent(params[k] || ''));
  return <Navigate to={doldur(yonetici ? admin : musteri)} replace />;
}
